export const CUSTOMIZATIONS_TABS = {
  ADD_INGREDIENTS: 'product-details-ingredients.add-ingredients',
  REVIEW: 'product-details-ingredients.review',
};
